import React, { forwardRef } from 'react';
import BaseButton from './BaseButton';

const CancelButton = forwardRef(({ title = 'Cancel', ...props }, ref) => (
  <BaseButton
    ref={ref}
    id='cancel-button'
    responsive
    icon='cancel'
    title={title}
    {...props}
  />
));

export default CancelButton;
